'use strict';

import './ext/polyfills/function-bind';
import './ext/polyfills/is-array';
import './ext/polyfills/object-assign';
import 'core-js/fn/promise';

import Sizzle from'sizzle';
import Raven from 'raven-js';

import * as url from './util/url';
import * as device from './util/device';
import extend from './util/extend';
import request from './util/request';
import Video from './modules/video';
import ErrorType from './constants/error-type';

const Debug = require('./util/debug')('svt-video');

const oldDefine = window.define;
window.define = false;

if (oldDefine !== undefined) {
	window.define = oldDefine;
} else {
	window.define = undefined;
}

Debug.log(`Version ${VERSION}`);

let Config = require('./config');

let isRavenConfigured = false;

/*
 * Configure Raven, which is the official SDK for Sentry. It is used to report
 * errors.
 */
const configureRaven = () => {
    // Sentry/Raven can be disabled in the config.
    if (!Config.sentry || typeof Config.sentry.dsn !== 'string') {
        return;
    }

    /*
     * We call Raven.config but never Raven.install, because we do not want to
     * pollute the global scope. Instead, we just configure the Sentry DSN and
     * rely on manually reporting errors via Raven.captureException calls.
     *
     * Some uncaught exceptions are reported by wrapping event handlers in
     * our custom event handler api. We also report errors in the error handler
     * plugin.
     */
    Raven.config(Config.sentry.dsn, {
        release: VERSION,
        environment: process.env.NODE_ENV, // eslint-disable-line no-process-env
        autoBreadcrumbs: false,
        instrument: false,
        sampleRate: Config.sentry.sampleRate,
        ignoreErrors: Config.sentry.ignoreErrors
    });
};

let SVTVideoPlayer = function (elements) {
	if (!elements) {
		return;
	}

    if (!isRavenConfigured && process.env.NODE_ENV !== 'development') { // eslint-disable-line no-process-env
        configureRaven();
        isRavenConfigured = true;
    }

	//NB: For memory testing - remove sizzle cache
	//Sizzle.selectors.cacheLength = 1;

	const videoContainerElements = Array.isArray(elements) ? elements : [elements];

	for (let i = 0; i < videoContainerElements.length; i++) {
		Video.initialize(videoContainerElements[i]);
	}
};

SVTVideoPlayer.version = VERSION;

SVTVideoPlayer.config = function (config) {
    if (config) {
        extend(Config, config);
    }

    return Config;
};

SVTVideoPlayer.extend = Video.addPlugin;
SVTVideoPlayer.destroy = Video.destroy;
SVTVideoPlayer.ErrorType = ErrorType;

SVTVideoPlayer.debug = function (isDebug, expression) {
    if (isDebug) {
        Debug.enable(expression);
    } else {
        Debug.disable();
    }
};

function loadCss() {
    const styleNode = document.createElement('link');
    styleNode.setAttribute('rel', 'stylesheet');
    styleNode.setAttribute('type', 'text/css');
    styleNode.setAttribute('href', url.absolutePath('svtvideoplayer.css'));

    let styleNodeLoadFn;

    if (styleNode.addEventListener) {
        SVTVideoPlayer._cssNotLoadedClass = 'svp_js--req-css';
        styleNodeLoadFn = () => {
            Debug('css loaded');
            styleNode.removeEventListener('load', styleNodeLoadFn);

            let nodes = Sizzle('.' + SVTVideoPlayer._cssNotLoadedClass);

            nodes.forEach((node) => {
                node.style.visibility = '';
            });

            SVTVideoPlayer._cssNotLoadedClass = undefined;
        };

        styleNode.addEventListener('load', styleNodeLoadFn);
        //Hack for old Androids and iOS 5 that don't get the load event
        setTimeout(() => {
            if (SVTVideoPlayer._cssNotLoadedClass) {
                styleNodeLoadFn();
            }
        }, 2000);
    }

    Sizzle('head')[0].appendChild(styleNode);
}

function loadLibs() {
	if (device.supportsDash()) {
        require.ensure(['dashjs'], () => {
            Debug('dashjs loaded');
        }, 'dash');
	}

    if (!device.supportsHls() && device.supportsHlsJs()) {
        require.ensure(['hls.js'], () => {
            Debug('hls.js loaded');
        }, 'hls');
    }

    request.getText('//www.svtstatic.se/video/geocheck/',
        () => {
            SVTVideoPlayer._inSweden = true;
        },
        () => {
            SVTVideoPlayer._inSweden = false;
        }
    );
}

function modifyConfigFromScriptSource() {
    const scriptNode = Sizzle('script[src*="/svtvideoplayer"]')[0];
    const stageOverride = url.getQueryParameter('svtIsStage') === 'true';
    const scriptSource = (scriptNode && scriptNode.getAttribute('src')) || '';

    let basePath = '';

    //if url don't starts with http or just // then add current browser location
    if (!/(^http(s)?:)|(^\/\/)/.test(scriptSource)) {
        const { host, protocol } = window.location;
        basePath = protocol + '//' + host;
    }

    basePath += scriptSource.split(/\/js\/svtvideoplayer.+\.js$/)[0] + '/';

    Config.basePath = basePath;
    Config.isStage = Boolean(stageOverride);

    if (stageOverride && Config.nojsPlayerBaseUrl) {
        Config.embedPlayerBaseUrl = Config.nojsPlayerBaseUrl.replace('api.svt', 'api.stage.svt');
    }

    // Dynamically set the webpack public path to the url that serves the
    // static player files. The public path is used by webpack when additional
    // chunks are loaded.
    __webpack_public_path__ = url.absolutePath('');
}

/**
 * Initialization starts here
 */
modifyConfigFromScriptSource();
loadCss();
loadLibs();

function onDOMContentLoaded() {
	SVTVideoPlayer(Sizzle('.svtvideoplayer'));
}

if (document.addEventListener) {
	document.addEventListener('DOMContentLoaded', onDOMContentLoaded);
} else {
	window.attachEvent('onload', onDOMContentLoaded);
}

module.exports = SVTVideoPlayer;




// WEBPACK FOOTER //
// ./src/js/svt-video.js